import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

//  Services
import { AuthenticationService } from '../../services/authentication.service';

@Component({
    selector: 'signin-component',
    templateUrl: './signin.component.html',
    providers: []
})

export class SignInComponent implements OnInit {

    username = '';
    password = '';

    constructor(
        private router: Router, 
        private authService: AuthenticationService
    ) {
    }

    ngOnInit() { }

    signIn() {
        
        this.authService.signIn(this.username, this.password)
        .subscribe(response => {
          this.authService.storeSession(response.token)
          this.router.navigate(['dashboard/abstracts']);
        }, err => {
          console.log(err);
          this.clearCredentials();
        });
    }

    dashboard() {
        this.router.navigate(['dashboard/abstracts']);
    }

    clearCredentials() {
        this.username = '';
        this.password = '';
    }
}



// WEBPACK FOOTER //
// ./src/app/components/signin/signin.component.ts